enum CourseType {
	Exam = "exam",
	Ordinary = "ordinary",
}

export default CourseType;
